var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5668 9.28534V3.97676L3.66602 0.970703V27.8973L15.5668 31.0313V25.7867L9.00785 24.1238V18.4314L15.5668 20.0944V14.9137L9.00785 13.1868V7.68637L15.5668 9.28534Z",
    fill: "#37384B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.331 0.970703L15.5654 3.97676V9.28534L27.331 6.34324V0.970703Z",
    fill: "#5F1314"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5654 14.9137V20.0944L21.9892 18.4314V24.1238L15.5654 25.7867V31.0313L27.331 27.9613V11.8437L15.5654 14.9137Z",
    fill: "#5F1314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBm);
export default __webpack_public_path__ + "static/media/bm.d4172522890e1a1e170481c5f2264002.svg";
export { ForwardRef as ReactComponent };